import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface FolhadePontoModalState {
    isModalOpen: boolean,
}

const initialState: FolhadePontoModalState = {
    isModalOpen: false,
}

const noApprovalModalState: FolhadePontoModalState = {
  isModalOpen: false,
}

export const timesheetModalSlice = createSlice({
    name: 'timesheetModal',
    initialState,
    reducers: {
      openModal: (state, action: PayloadAction<FolhadePontoModalState>) => {
        state.isModalOpen = action.payload.isModalOpen
      }
    },
})

export const timesheetNoApprovalModalSlice = createSlice({
    name: 'timesheetNoApprovalModal',
    initialState: noApprovalModalState,
    reducers: {
      openNoApprovalModal: (state, action: PayloadAction<FolhadePontoModalState>) => {
        state.isModalOpen = action.payload.isModalOpen
      }
    },
  })
  
  export const { openModal } = timesheetModalSlice.actions
  export const { openNoApprovalModal } = timesheetNoApprovalModalSlice.actions
